import React, { useState, useEffect } from 'react';
import OtpInput from 'react-otp-input';

import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import Form from 'react-bootstrap/Form';

import '../App.css';
import { useTimecampService } from '../services/timecamp.service';

export const Home = (props: { setRoute: (e: string) => void }) => {
    const { addTimeEntry, pageVisit } = useTimecampService();

    const [otp, setOtp] = useState<string>('');
    const [message, setMessage] = useState<string>('');
    const [isLoading, setLoading] = useState<boolean>(false);
    const [alert, setAlert] = useState<string>('');

    useEffect(() => {
        pageVisit({page: 'timeentry-page'})
    }, []);

    const handleOtpChange = (_otp: string) => {
        setOtp(_otp);
    };

    const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setLoading(true);
        setMessage('');
        addTimeEntry({ pin: otp })
            .then((res) => {
                setAlert(res.message);
                setTimeout(() => {
                    setAlert('');
                    setOtp('');
                }, 3000);
            })
            .catch((e: Error) => {
                setMessage(e?.message || 'Incorrect pin! Try again.');
                setOtp('');
            }).finally(() => {
                setLoading(false);
            });
    }

    if (alert) {
        return <h2>
            <p>Correct pin! Have a good day!</p>
            <Badge bg="secondary">{alert}</Badge>
        </h2>;
    }

    return <Form className='Pin-form' onSubmit={handleFormSubmit}>
        <h3>Enter your individual pin to start or finish your workday</h3>
        <OtpInput
            inputStyle="inputStyle"
            numInputs={4}
            hasErrored={false}
            errorStyle="error"
            onChange={handleOtpChange}
            isInputNum={true}
            shouldAutoFocus
            value={otp}
            isInputSecure
            containerStyle={{ justifyContent: 'center', margin: '1rem 0' }}
        />
        {message ? <p>{message}</p> : null}
        <Button variant="primary" size="lg" type="submit" disabled={otp.length < 4}>
            {isLoading ? <Spinner animation="border" /> : 'Done'}
        </Button>
    </Form>;
}